import { render, staticRenderFns } from "./regTypeCard.vue?vue&type=template&id=2319189f&scoped=true"
import script from "./regTypeCard.vue?vue&type=script&lang=js"
export * from "./regTypeCard.vue?vue&type=script&lang=js"
import style0 from "./regTypeCard.vue?vue&type=style&index=0&id=2319189f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319189f",
  null
  
)

export default component.exports